<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <circle cx="4" cy="4" r="5" transform="matrix(-1 0 0 1 10 2)" fill="#3751FF" stroke="#F2F4F8" stroke-width="2"/>
</svg>